import React, { createContext, useContext } from 'react';

type EventProperties = {
  description: string;
  [key: string]: string | boolean | number | undefined;
};

export interface SDMAnalyticsLogger {
  trackSDMEvent(eventName: string, properties: EventProperties): void;
}

const noopLogger: SDMAnalyticsLogger = {
  trackSDMEvent: () => {},
};

const AnalyticsContext = createContext<SDMAnalyticsLogger>(noopLogger);

export function useSDMAnalytics(): SDMAnalyticsLogger {
  return useContext(AnalyticsContext);
}

export function SDMAnalyticsProvider({
  logger,
  children,
}: {
  logger: SDMAnalyticsLogger;
  children: React.ReactNode;
}) {
  return <AnalyticsContext.Provider value={logger}>{children}</AnalyticsContext.Provider>;
}
